import './index.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Glowna from './Components/GlownaStrona';
import About from './Components/Inne-Strony/About/About';
import AnimatedRoutes from './Components/Zanimowane/AnimatedRoutes';
import ProjectsPageWrapper from './Components/ProjectsPage/ProjectsPageWrapper';
import ProjectPage from './Components/ProjectsPage/ProjectPage';
import GradioPage from './Components/GradioRequest';

function App() {
  return (
    <Router>
      <AnimatedRoutes>
        <Route path="/portfolio" element={<Glowna />} />
        <Route path="/portfolio/about" element={<About />} />
        <Route path="/portfolio/projects" element={<ProjectsPageWrapper />} />
        <Route path='/portfolio/projects/:projectId' element={<ProjectPage/> } />
        <Route path='/portfolio/gradio' element={<GradioPage/> } />
      </AnimatedRoutes>
    </Router>
  );
}

export default App;
